// src/components/ChatLauncher.jsx
import { useEffect, useState } from "react";
import GeminiChat from "./GeminiChat";

export default function ChatLauncher({
  apiBase = "",
  openInitial = true,      // 👈 start OPEN on first render
  autoGreet = true,        // 👈 bot sends first message
  greetingText = "👋 Hello! I’m your DIWASA Assistant. How can I help today?",
}) {
  const [open, setOpen] = useState(openInitial);

  // (Optional) focus the window a tick after mount so it feels instant
  useEffect(() => {
    if (!open) setOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // runs once when the component mounts

  return (
    <div style={{ position: "relative" }}>
      {open && (
        <div
          style={{
            width: 420,
            height: 560,
            borderRadius: 18,
            overflow: "hidden",
            background: "#fff",
            border: "1px solid #e5e7eb",
            boxShadow: "0 20px 40px rgba(2,6,23,.15)",
          }}
        >
          <GeminiChat
            apiBase={apiBase}
            onClose={() => setOpen(false)}   // ✕ still closes it
            autoGreet={autoGreet}
            greetingText={greetingText}
          />
        </div>
      )}

      {/* If you still want a reopen button after close, keep this: */}
   {!open && (
  <button
    onClick={() => setOpen(true)}
    type="button"
    title="Chat with DIWASA"
    style={{
      width: 56,
      height: 56,
      borderRadius: "50%",
      background: "linear-gradient(135deg,#4f46e5,#2563eb)",
      color: "#fff",
      border: 0,
      cursor: "pointer",
      boxShadow: "0 12px 24px rgba(37,99,235,.35)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="white"
      width="28"
      height="28"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 21a8.25 8.25 0 0115 0"
      />
    </svg>
  </button>
)}


    
    </div>
  );
}
